<!--
  Encerramento de uma unidade da rede (chamado NS 2026-0082, entrega 4; Full): o espelho do
  onboarding. O checklist (distrato, linha, backup do WhatsApp, maquinário, bens e uniformes,
  exclusão do site, conferência do jurídico), cada item com situação e observação; o distrato e
  as observações; a unidade, quando o encerramento veio da planilha sem casar; e o "Concluir",
  que leva a unidade a Encerrada ou Repassada (com o novo franqueado). Quem decide o que impede
  concluir é o app-api; a tela só mostra o motivo.
  Abre por eventBus.emit('modal.rede-encerramento.open', { id }) ou, para abrir um novo,
  { unidade: 'f:12' | 'e:5', nome }; avisa 'rede.situacao.atualizada' (a lista e o painel recarregam).
-->
<template>
  <Modal v-if="isVisible" :title="titulo" :visible="isVisible" :closable="true" :style="{ width: '900px', maxWidth: '96vw' }" data-testid="rede-encerramento-modal" @update:visible="fechar">
    <p v-if="carregandoDados" class="quieto">{{ t('Carregando…') }}</p>
    <form v-else class="encerramento" data-testid="rede-encerramento-form" @submit.prevent="gravar(false)">
      <p class="quieto">
        <template v-if="atual">{{ t(ORIGENS[atual.origem] ?? atual.origem) }}. </template>
        <template v-if="atual && atual.nome_registrado && atual.nome_registrado !== atual.nome">{{ t('Na planilha') }}: {{ atual.nome_registrado }}. </template>
        <template v-if="!atual">{{ t('Novo encerramento: grave o checklist para abrir.') }}</template>
      </p>
      <p v-if="concluido" class="feito" data-testid="rede-encerramento-concluido">
        {{ t(atual?.destino === 'repassada' ? 'Concluído: unidade repassada em' : 'Concluído: unidade encerrada em') }} {{ dataBr(atual?.concluido_em) }}
        <template v-if="atual?.novo_franqueado"> — {{ t('novo franqueado') }}: {{ atual.novo_franqueado }}</template>
        <span class="quieto"> ({{ atual?.concluido_por }})</span>
      </p>
      <p v-if="atual?.a_conferir && !concluido" class="alerta" data-testid="rede-encerramento-a-conferir">
        {{ t('A conferir') }}<template v-if="atual.divergencia">: {{ atual.divergencia }}</template>
      </p>

      <select-list v-if="!unidadeAtual && !concluido" v-model="unidadeEscolhida" elem-id="rede-encerramento-unidade" data-testid="rede-encerramento-unidade"
                   :itens-select="opcoesDeUnidade" :auto-select-first="false" :label="t('Unidade da base (para casar)')" />

      <section class="secao">
        <h4>{{ t('Checklist') }} <span v-if="!concluido" class="quieto" data-testid="rede-encerramento-pendentes">({{ pendentes }} {{ t('pendentes') }})</span></h4>
        <div v-for="item in itens" :key="item.item" class="item" :data-testid="`rede-encerramento-item-${item.item}`">
          <strong>{{ t(item.rotulo) }}</strong>
          <select-list v-model="item.situacao" :elem-id="`rede-encerramento-situacao-${item.item}`" :data-testid="`rede-encerramento-situacao-${item.item}`"
                       :itens-select="opcoesDeSituacao" :auto-select-first="false" :disabled="concluido" :label="t('Situação')" />
          <input-text v-model="item.observacao" :elem-id="`rede-encerramento-observacao-${item.item}`" :data-testid="`rede-encerramento-observacao-${item.item}`"
                      :disabled="concluido" :label="t('Observação')" />
        </div>
      </section>

      <section class="secao grade">
        <input-text v-model="distrato" elem-id="rede-encerramento-distrato" data-testid="rede-encerramento-distrato" :disabled="concluido" :label="t('Distrato (texto)')" />
        <input-date v-model="distratoEm" elem-id="rede-encerramento-distrato-em" data-testid="rede-encerramento-distrato-em" :disabled="concluido" :label="t('Data do distrato')" />
        <input-text-area v-model="observacao" class="largo" elem-id="rede-encerramento-obs" data-testid="rede-encerramento-obs" :disabled="concluido" :label="t('Observações')" :rows="2" />
        <input-text-area v-model="conferencia" class="largo" elem-id="rede-encerramento-conferencia" data-testid="rede-encerramento-conferencia" :disabled="concluido" :label="t('Conferência do jurídico')" :rows="2" />
      </section>

      <div v-if="!concluido" class="botoes">
        <app-button type="submit" :label="t('Gravar')" icon="pi pi-save" :loading="gravando" :disabled="!atual && !unidadeAtual" data-testid="rede-encerramento-gravar" />
        <app-button v-if="atual?.a_conferir" :label="t('Gravar e marcar como conferido')" icon="pi pi-check" severity="secondary" :loading="gravando" data-testid="rede-encerramento-conferido" @click="gravar(true)" />
        <span v-if="atual" class="quieto">{{ t('Última gravação') }}: {{ atual.atualizado_por }}</span>
      </div>

      <section v-if="atual && !concluido" class="secao concluir" data-testid="rede-encerramento-concluir-secao">
        <h4>{{ t('Concluir') }}</h4>
        <div class="grade">
          <select-list v-model="destino" elem-id="rede-encerramento-destino" data-testid="rede-encerramento-destino" :itens-select="opcoesDeDestino" :auto-select-first="false" :label="t('A unidade foi')" />
          <input-date v-model="desde" elem-id="rede-encerramento-desde" data-testid="rede-encerramento-desde" :label="t('Desde')" />
          <input-text v-if="destino === 'repassada'" v-model="novoFranqueado" elem-id="rede-encerramento-novo" data-testid="rede-encerramento-novo" :label="t('Novo franqueado')" />
        </div>
        <p v-if="motivoParaNaoConcluir" class="quieto" data-testid="rede-encerramento-motivo">{{ t(motivoParaNaoConcluir) }}</p>
        <div class="botoes">
          <app-button :label="t('Concluir encerramento')" icon="pi pi-flag" severity="danger" :loading="concluindo" :disabled="motivoParaNaoConcluir !== ''" data-testid="rede-encerramento-concluir" @click="concluir" />
        </div>
      </section>
    </form>
  </Modal>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import InputDate from '../../inputs/InputDate.vue';
import InputText from '../../inputs/InputText.vue';
import InputTextArea from '../../inputs/InputTextArea.vue';
import SelectList from '../../inputs/SelectList.vue';
import { useRede, mensagemDaRede, SITUACOES_DO_ITEM } from '../../composables/useRede';
import { eventBus } from '../../eventBus';
import type { Rede_EncerramentoResponseDados } from '../../contracts/Rede_EncerramentoResponse';

const { t } = useI18n();
const { carregarEncerramento, salvarEncerramento, concluirEncerramento, carregarUnidades } = useRede();

const ORIGENS: Record<string, string> = { planilha: 'Da aba Retornos da planilha', juridico: 'Incluído pelo Jurídico', manual: 'Aberto pela tela' };
/** Os itens de um encerramento novo, na ordem do app-api (EncerramentoDaUnidade::ITENS). */
const ITENS_NOVOS: [string, string][] = [
  ['distrato', 'Distrato'], ['linha_telefonica', 'Transferência de linha'], ['backup_whatsapp', 'Backup do WhatsApp e contatos'], ['maquinario', 'Maquinário'],
  ['bens_uniformes', 'Bens e uniformes'], ['exclusao_site', 'Exclusão do site'], ['juridico', 'Conferência do jurídico'],
];

type Item = { item: string; rotulo: string; situacao: string; observacao: string };

const isVisible = ref(false);
const carregandoDados = ref(false);
const atual = ref<Rede_EncerramentoResponseDados | null>(null);
const unidadeNova = ref('');
const nomeNovo = ref('');
const unidadeEscolhida = ref('');
const itens = ref<Item[]>([]);
const distrato = ref('');
const distratoEm = ref('');
const observacao = ref('');
const conferencia = ref('');
const destino = ref('');
const desde = ref('');
const novoFranqueado = ref('');
const gravando = ref(false);
const concluindo = ref(false);
const opcoesDeUnidade = ref<{ ID: string; Name: string }[]>([]);

const opcoesDeSituacao = computed(() => SITUACOES_DO_ITEM.map((s) => ({ ID: s.chave, Name: t(s.rotulo) })));
const opcoesDeDestino = computed(() => [{ ID: 'encerrada', Name: t('Encerrada') }, { ID: 'repassada', Name: t('Repassada') }]);
const concluido = computed(() => atual.value?.situacao === 'concluido');
const unidadeAtual = computed(() => atual.value?.unidade ?? (unidadeNova.value || null));
const titulo = computed(() => `${t('Encerramento')}: ${atual.value?.nome ?? nomeNovo.value}`);
const dataBr = (iso: string | null | undefined): string => (iso ? iso.slice(0, 10).split('-').reverse().join('/') : '');

/** O mesmo critério do app-api, para a tela dizer antes de enviar. */
const resolvido = (i: Item): boolean => ['feito', 'nao_se_aplica'].includes(i.situacao) || (i.situacao !== 'pendente' && i.observacao.trim() !== '');
const pendentes = computed(() => itens.value.filter((i) => !resolvido(i)).length);
const motivoParaNaoConcluir = computed((): string => {
  if (!unidadeAtual.value) return 'Escolha a unidade do encerramento antes de concluir.';
  if (pendentes.value > 0) return 'Resolva todos os itens: feito, não se aplica, ou com a observação de por que não.';
  if (!destino.value) return 'Escolha se a unidade foi encerrada ou repassada.';
  if (!desde.value) return 'Informe a data.';
  if (destino.value === 'repassada' && !novoFranqueado.value.trim()) return 'Informe o novo franqueado do repasse.';
  return '';
});

const preencher = (e: Rede_EncerramentoResponseDados): void => {
  atual.value = e;
  itens.value = e.itens.map((i) => ({ item: i.item, rotulo: i.rotulo ?? i.item, situacao: i.situacao, observacao: i.observacao ?? '' }));
  distrato.value = e.distrato ?? '';
  distratoEm.value = e.distrato_em ?? '';
  observacao.value = e.observacao ?? '';
  conferencia.value = e.conferencia_juridico ?? '';
};

const limpar = (): void => {
  atual.value = null;
  unidadeNova.value = '';
  nomeNovo.value = '';
  unidadeEscolhida.value = '';
  itens.value = ITENS_NOVOS.map(([item, rotulo]) => ({ item, rotulo, situacao: 'pendente', observacao: '' }));
  distrato.value = '';
  distratoEm.value = '';
  observacao.value = '';
  conferencia.value = '';
  destino.value = '';
  desde.value = '';
  novoFranqueado.value = '';
};

const erro = (e: unknown): void => {
  eventBus.emit('globalMessage.error', t(mensagemDaRede(e)));
};

const abrir = (dados?: { id?: number; unidade?: string; nome?: string }): void => {
  limpar();
  isVisible.value = true;
  if (!dados?.id) {
    unidadeNova.value = dados?.unidade ?? '';
    nomeNovo.value = dados?.nome ?? '';
    return;
  }
  carregandoDados.value = true;
  carregarEncerramento(dados.id)
    .then((e) => {
      preencher(e);
      // Sem unidade, a tela oferece as da base para casar.
      if (!e.unidade && e.situacao !== 'concluido') {
        return carregarUnidades().then((us) => {
          opcoesDeUnidade.value = us.map((u) => ({ ID: u.franquia_id ? `f:${u.franquia_id}` : `e:${u.externa_id}`, Name: u.nome + (u.no_sistema ? '' : ` ${t('(fora do sistema)')}`) }));
        });
      }
      return undefined;
    })
    .catch(erro)
    .finally(() => {
      carregandoDados.value = false;
    });
};

const fechar = (): void => {
  isVisible.value = false;
};

const gravar = async (conferido = false): Promise<void> => {
  gravando.value = true;
  try {
    const e = await salvarEncerramento({
      id: atual.value?.id ?? 0,
      unidade: atual.value ? (unidadeEscolhida.value || undefined) : unidadeNova.value,
      itens: itens.value.map((i) => ({ item: i.item, situacao: i.situacao, observacao: i.observacao.trim() || undefined })),
      // Vazio vai como ausente: o app-api grava null.
      distrato: distrato.value.trim() || undefined,
      distrato_em: distratoEm.value || undefined,
      observacao: observacao.value.trim() || undefined,
      conferencia_juridico: conferencia.value.trim() || undefined,
      conferido,
    });
    preencher(e);
    unidadeEscolhida.value = '';
    eventBus.emit('globalMessage.success', t('Encerramento gravado'));
    eventBus.emit('rede.situacao.atualizada');
  } catch (e) {
    erro(e);
  } finally {
    gravando.value = false;
  }
};

const concluir = async (): Promise<void> => {
  if (!atual.value) return;
  concluindo.value = true;
  try {
    const e = await concluirEncerramento({ id: atual.value.id, destino: destino.value, desde: desde.value, ...(destino.value === 'repassada' ? { novo_franqueado: novoFranqueado.value.trim() } : {}) });
    preencher(e);
    eventBus.emit('globalMessage.success', t('Encerramento concluído'));
    eventBus.emit('rede.situacao.atualizada');
  } catch (e) {
    erro(e);
  } finally {
    concluindo.value = false;
  }
};

eventBus.on('modal.rede-encerramento.open', abrir);
onBeforeUnmount(() => {
  eventBus.off('modal.rede-encerramento.open', abrir);
});
</script>

<style scoped>
.encerramento { display: flex; flex-direction: column; gap: 14px; }
.secao h4 { margin: 0 0 8px; font-size: 15px; }
.item { display: grid; grid-template-columns: 1.3fr 1fr 2fr; gap: 10px; align-items: end; margin-bottom: 8px; }
.item strong { align-self: center; }
.grade { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
.largo { grid-column: 1 / -1; }
.concluir { border-top: 1px solid #e5e3dc; padding-top: 12px; }
.botoes { display: flex; gap: 12px; align-items: center; flex-wrap: wrap; }
.alerta { margin: 0; padding: 8px 12px; border-radius: 8px; background: #fff1d6; color: #9a6700; font-weight: 700; }
.feito { margin: 0; padding: 8px 12px; border-radius: 8px; background: #e3f2ea; color: #1e7b4f; font-weight: 700; }
.quieto { color: #5b6168; font-size: 13px; margin: 0; font-weight: 400; }
@media (max-width: 800px) { .item, .grade { grid-template-columns: minmax(0, 1fr); } }
</style>
